require("./compile/unminified/ng-img-crop.js");
module.exports = "ngImgCrop";



//////////////////
// WEBPACK FOOTER
// ../~/ng-img-crop-npm/index.js
// module id = 23
// module chunks = 0